"use strict";

require("core-js/modules/es.array.flat-map");

require("core-js/modules/es.array.unscopables.flat-map");

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray");

exports.__esModule = true;
exports.getId = getId;
exports.noop = noop;
exports.walkTree = walkTree;
exports.arrayFrom = arrayFrom;
exports.flatMap = flatMap;
exports.addClass = addClass;
exports.childSelector = childSelector;
var uniqId = Math.random().toString(36).slice(2, 8);
var globalIndex = 0;

function getId() {
  globalIndex += 1;
  return "mm-".concat(uniqId, "-").concat(globalIndex);
}

function noop() {// noop
}

function walkTree(tree, callback) {
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'c';

  var walk = function walk(item, parent) {
    return callback(item, function () {
      var _item$key;

      (_item$key = item[key]) == null ? void 0 : _item$key.forEach(function (child) {
        walk(child, item);
      });
    }, parent);
  };

  walk(tree);
}

function arrayFrom(arrayLike) {
  if (Array.from) return Array.from(arrayLike);
  var array = [];

  for (var i = 0; i < arrayLike.length; i += 1) {
    array.push(arrayLike[i]);
  }

  return array;
}

function flatMap(arrayLike, callback) {
  if (arrayLike.flatMap) return arrayLike.flatMap(callback);
  var array = [];

  for (var i = 0; i < arrayLike.length; i += 1) {
    var result = callback(arrayLike[i], i, arrayLike);
    if (Array.isArray(result)) array.push.apply(array, _toConsumableArray(result));else array.push(result);
  }

  return array;
}

function addClass(className) {
  var classList = (className || '').split(' ').filter(Boolean);

  for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    rest[_key - 1] = arguments[_key];
  }

  rest.forEach(function (item) {
    if (item && classList.indexOf(item) < 0) classList.push(item);
  });
  return classList.join(' ');
}

function childSelector(filter) {
  if (typeof filter === 'string') {
    var tagName = filter;

    filter = function filter(el) {
      return el.tagName === tagName;
    };
  }

  var filterFn = filter;
  return function selector() {
    var nodes = arrayFrom(this.childNodes);
    if (filterFn) nodes = nodes.filter(function (node) {
      return filterFn(node);
    });
    return nodes;
  };
}